import { useContext } from 'react';
import { ReleasePageContext } from './ReleasePageContext';

export const useReleasePageContext = () => useContext(ReleasePageContext);
